import { StoreWithStrapi } from "../../types/types";
import { createSelector } from "@reduxjs/toolkit";

export const selectLinkedActions = (state: StoreWithStrapi): any[] =>
  state.gop.reports?.linkedActions?.data || [];

export const selectLinkedActionsLoading = (state: StoreWithStrapi): boolean =>
  state.gop.reports?.linkedActions?.loading || false;

export const selectLinkedActionsError = (state: StoreWithStrapi): string | null =>
  state.gop.reports?.linkedActions?.error || null;

export const selectLinkedActionsOnly = createSelector(
  [selectLinkedActions],
  (linkedActions) => linkedActions.filter(action => action.isLinked)
);

export const selectActionByContext = (state: StoreWithStrapi): any[] =>
  state.gop.gop.actionByContext?.data || [];

export const selectActionByContextLoading = (state: StoreWithStrapi): boolean =>
  state.gop.gop.actionByContext?.loading || false;

export const selectActionByContextError = (state: StoreWithStrapi): string | null =>
  state.gop.gop.actionByContext?.error || null;